import { useAppContext } from "../../App";
import "./ImageRender.css";

type ImageRenderProps = {
  classname?: string;
  name?: string;
  path: string;
};

function ImageRender({ classname, path, name }: ImageRenderProps) {
  const appContext = useAppContext();

  const viewImage = () => {
    appContext?.setViewFile({
      path: path,
      type: "image",
      title: name,
    });
  };

  return (
    <div className={`image-render ${classname}`}>
      <img
        src={path}
        alt={`render-${path}`}
        onClick={viewImage}
        onContextMenu={(e) => e.preventDefault()}
      />
    </div>
  );
}

export default ImageRender;
